// extracted by mini-css-extract-plugin
export default {"row":"Row_row__K9elE","loading":"Row_loading__Fdi6N","spin":"Row_spin__NO9yP"};